import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const Input = ({
  socialLoginMode,
  submitted,
  type,
  className,
  id,
  placeHolder,
  formFieldName,
  ariaLabel,
  testId,
  name,
  functionOnchange,
  functionOnkeyDown,
  disabled,
  pattern,
  role,
  value,
  alt,
  consentText,
  emailAutoFocus,
  isEmployerSignup,
  isPartnerSignup

}) => {
  const [unfocused, setUnfocused] = useState(false);

  const handleUnfocused = (e) => {
    setUnfocused(true);
  };


  const location = useLocation()



  return (
    <>
      {socialLoginMode !== undefined ? (
        <input
          type={type}
          className={className}
          placeholder={placeHolder}
          aria-label={ariaLabel}
          data-testid={testId}
          id={id}
          onChange={functionOnchange}
          onKeyDown={functionOnkeyDown}
          name={name}
          disabled={type === "email" ? "disabled" : null}
          pattern={pattern}
          role={role}
          alt={alt}
          onBlur={handleUnfocused}
          focused={submitted ? null : unfocused.toString()}
          value={type === "email" ? socialLoginMode : name === "firstName" ? value : name === "lastName" ? value : null}
          autoFocus={type === "email" && emailAutoFocus === true ? true : false}
        />
      ) : (
        <input
          type={type}
          className={`${className} ${type === "email" && emailAutoFocus === true && isEmployerSignup === true ? "email-auto-focus" : ""}`}
          placeholder={placeHolder}
          aria-label={ariaLabel}
          data-testid={testId}
          id={`${id} ${type === "email" && emailAutoFocus === true ? "emailAutoFocusField" : ""}`}
          onChange={functionOnchange}
          onKeyDown={functionOnkeyDown}
          name={name}
          disabled={disabled === true ? "disabled" : null}
          pattern={pattern}
          role={role}
          alt={alt}
          onBlur={handleUnfocused}
          onFocus={() => name === "confirmPassword" && setUnfocused(true)}
          focused={submitted ? null : unfocused.toString()}
          autoFocus={type === "email" && emailAutoFocus === true ? true : false}
        />
      )}

      {id === "termsAndCondition" || id === "ageVerification" ?
        <label className="form-check-label" htmlFor={id}>
          {consentText}
        </label>
        :
        <label htmlFor={id} className="label-name">
          {formFieldName}
          {
            (location.pathname === "/role_selection/professional_signup/manual") ||
              (location.pathname === "/role_selection/employer_signup/manual") ||
              (location.pathname === "/role_selection/partner_signup/manual" && formFieldName !== "Website") ||
              (location.pathname === "/role_selection/professional_signup/social_media" && formFieldName !== "Email")
              ?
              <span className="asterisk"> <>&nbsp;*</> </span>
              :
              null
            /* // isPartnerSignup === true && formFieldName === "Website" || id === "login-email-id" || id === "login-pass" || id === "reset-email" || type === "checkbox" ? */
          }
        </label>
      }
    </>
  );
};

export default Input;